<style lang="less">
.account-info-vue {
  padding: 24px 30px 30px;
  max-width: none;

  .h-form-item-label {
    text-align: right;
  }

  .h-form-item-content {
    .h-input,
    .h-textarea {
      width: 100%;
    }
  }
}
</style>
<template>
  <div class="account-info-vue">
    <Form
      :model="acc"
      :rules="rules"
      ref="form"
      :label-width="64"
      labelPosition="right"
      showErrorTip
    >
      <FormItem label="头像" prop="avatar">
        <Upload display-type="image" data-type="url" v-model="acc.avatar" />
      </FormItem>
      <FormItem label="用户名" prop="username">
        <Input type="text" v-model="acc.username" />
      </FormItem>
      <FormItem label="描述" prop="desc">
        <Textarea v-autosize v-model="acc.desc" />
      </FormItem>
      <FormItem label="">
        <Button color="primary" @click="save" :loading="saveloading">保存</Button>
        <Button @click="reset">重置</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import utils from '@common/utils';

export default {
  props: {
    account: Object
  },
  data() {
    return {
      acc: this.copyAccount(this.account),
      rules: {
        required: ['username']
      },
      saveloading: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    copyAccount(account) {
      const acc = utils.copy(account || {});
      acc.username = acc.username || acc.name || '';
      acc.name = acc.username;
      return acc;
    },
    init() {},
    save() {
      if (!this.$refs.form.valid().result) return;
      this.saveloading = true;
      this.acc.name = this.acc.username;
      setTimeout(() => {
        this.saveloading = false;
        this.$store.dispatch('updateAccount', utils.copy(this.acc));
      }, 1000);
    },
    reset() {
      this.$refs.form.resetValid();
      this.acc = this.copyAccount(this.account);
    }
  },
  computed: {}
};
</script>
